import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Stack,
  Container,
  CircularProgress,
  Card,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Breadcrumbs from 'components/Breadcrumbs';
import ContractParamsForm from 'sections/settings/ContractParamsForm';

import { getContractParams } from 'services/requests/contract';
import { toast } from 'utils';

export default function ContractParams() {
  const navigate = useNavigate()

  const [data, setData] = useState(null)
  const [loadingData, setLoadingData] = useState(true)

  const getData = () => {
    getContractParams()
      .then((res) => setData(res))
      .catch((err) => {
        toast(err, 'error')
        navigate('/', { replace: true })
      })
      .finally(() => setLoadingData(false));
  }

  useEffect(() => {
    getData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>Configurações de Contrato | { process.env.REACT_APP_PROJECT_NAME }</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Breadcrumbs
            items={[
              { label: 'Configurações de Contrato' }
            ]}
          />
        </Stack>

        <Stack>
          {
            loadingData ? (
              <Stack spacing={3} alignItems="center">
                <CircularProgress size={80} sx={{ my: 12 }} />
              </Stack>
            ) : data ? (
              <Card>
                <CardContent mt={2}>
                  <ContractParamsForm
                    defaultValues={data}
                  />
                </CardContent>
              </Card>
            ) : null
          }
        </Stack>
      </Container>
    </>
  )
}
